var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileMeh = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 50 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9879c3",
  fillRule: "evenodd",
  d: "M50 25c0 13.8-11.2 25-25 25S0 38.8 0 25 11.2 0 25 0s25 11.2 25 25m-28.5-2.2v-6.4c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v6.4c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2zm9.6 0v-6.4c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2v6.4c0 .7.5 1.2 1.2 1.2.6 0 1.2-.5 1.2-1.2zm4.4 10.6c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1H14.7c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1z",
  clipRule: "evenodd"
})));
export default SvgSmileMeh;